import "../../styles/products.css";
import ProductsHero from "./productsHero";
import ProductsMain from "./productsMain";
import ProductsFaq from "./productsFaq";
import ProductsClients from "./productsClients";

function Products() {
  return (
    <div>
      <ProductsHero />
      <ProductsMain />
      <ProductsFaq />
      <ProductsClients />
    </div>
  );
}

export default Products;
